export const track = (event, params = {}) => {
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", event, params);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, ...params });
    }
  } catch (e) {
    /* analytics must never break the page */
  }
};
